import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: []
}
//types
const OBTENER_USUARIOS_DIVISION_EXITO = 'OBTENER_USUARIOS_DIVISION_EXITO'
const AGREGAR_USUARIOS_DIVISION_EXITO = 'AGREGAR_USUARIOS_DIVISION_EXITO'
const ACTUALIZAR_USUARIOS_DIVISION_EXITO = 'ACTUALIZAR_USUARIOS_DIVISION_EXITO'
const ELIMINAR_USUARIOS_DIVISION_EXITO = 'ELIMINAR_USUARIOS_DIVISION_EXITO'


export const obtenerUsuarioDA = createAsyncThunk(
    OBTENER_USUARIOS_DIVISION_EXITO,
    async () => {
        try {
            const fullUrl = host + `Auth/obtenerUsersDA`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarUsuarioDA = createAsyncThunk(
    AGREGAR_USUARIOS_DIVISION_EXITO,
    async (data) => {
        let permisosagricola = {
            registroPredio: data.registroPredio,
            descuentoPredio: data.descuentoPredio,
            reportes: data.reportes,
            edicionDatos: data.edicionDatos,
            generarGuias: data.generarGuias,
            catalogoMaguey: data.catalogoMaguey,
            constancias: data.constancias,
            informacionAsociados: data.informacionAsociados,
            informacionPredios: data.informacionPredios
        }

        const dataLogin = {
            usuario: data.usuario,
            password: data.password,
            idtipousuario: Number(data.idtipousuario),
            idrol: Number(data.idrol),
            iddatoslogin: null,
            fechainscripcion: data.fechainscripcion,
            permisosagricola: permisosagricola
        }

        try {
            const urlAgregarLogin = host + `Auth/registrarDA`
            const resLogin = await axios.post(urlAgregarLogin, { data:dataLogin } )
            return resLogin.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarUsuarioDA = createAsyncThunk(
    ACTUALIZAR_USUARIOS_DIVISION_EXITO,
    async (data) => {
        let permisosagricola = {
            registroPredio: data.registroPredio,
            descuentoPredio: data.descuentoPredio,
            reportes: data.reportes,
            edicionDatos: data.edicionDatos,
            generarGuias: data.generarGuias,
            catalogoMaguey: data.catalogoMaguey,
            constancias: data.constancias,
            informacionAsociados: data.informacionAsociados,
            informacionPredios: data.informacionPredios
        }

        const dataLogin = {
            idlogin: data.idlogin,
            usuario: data.usuario,
            password: data.password,
            idtipousuario: Number(data.idtipousuario),
            idrol: Number(data.idrol),
            iddatoslogin: null,
            fechainscripcion: data.fechainscripcion,
            permisosagricola: permisosagricola
        }

        try {
            const urlActualizarLogin = host + `Auth/actualizarDA`
            const resLogin = await axios.put(urlActualizarLogin, { data: dataLogin })
            return resLogin.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarUsuarioDA = createAsyncThunk(
    ELIMINAR_USUARIOS_DIVISION_EXITO,
    async (idlogin) => {
        try {

            const fullUrlSolicitud = host + `Auth/eliminarDA/${idlogin}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return resultDelete
        } catch (error) {
            console.log(error);
        }
    }
)


export const UsuarioDivisionAgricolaSlice = createSlice({
    name: 'UsuarioDivisionAgricolaSlice',
    initialState: dataInicial,
    reducers: {

    },
    extraReducers: {

        [obtenerUsuarioDA.fulfilled]: (state, { payload }) => {
            state.data = payload
        },

    },
})


export const { } = UsuarioDivisionAgricolaSlice.actions
export const UsuarioDivisionAgricolaReducer = UsuarioDivisionAgricolaSlice.reducer
